<template>
  <div>
    <label v-if="title" for=""
      >{{ ("selector_" + titleKey) | setText(title) }}
    </label>
    <div class="selector">
      <ul :tag="'ul'">
        <li v-for="v in val" :key="v.id">
          <span>
            {{ v[selectKey] }}
            <span class="text-success" v-if="input"> ({{ v[input] }})</span>
          </span>
          <span @click="clearItem(v.id)"> ✕ </span>
        </li>
      </ul>
      <div @click="open" class="background" />
      <span v-if="disabled !== true" @click="open" class="ti-angle-down"></span>
    </div>
    <list-item
      :modal="modal"
      :url="url"
      v-model="val"
      :prefix="prefix"
      :params="params"
    />
  </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
  data: () => ({
    // val: null,
  }),
  props: {
    input: {
      default: "",
    },
    url: {
      default: "",
    },
    title: {
      default: "",
    },
    titleKey: {
      default: "",
    },
    disabled: {
      default: false,
    },
    value: {
      default: "",
    },
    modal: {
      default: "",
    },
    selectKey: {
      default: "",
    },
    prefix: {
      default: "",
    },
    fieldKey: {
      default: "",
    },
    params: {
      default: function () {
        return {};
      },
    },
  },
  computed: {
    val: {
      get() {
        //console.log('get: ',this.value);
        return this.value;
      },
      set(val) {
        // console.log('set: ',val);
        this.$emit("input", val, this.fieldKey);
      },
    },
  },
  components: {
    "list-item": () => import("../Modals/ListItem"),
    draggable,
  },
  methods: {
    open() {
      if (this.disabled === true) {
        return false;
      }
      this.$modal.show(`${this.modal}${this.prefix}`);
    },
    clearItem(id) {
      this.val = [...this.val].filter((item) => {
        return item.id != id;
      });
    },
  },
};
</script>
<style lang="scss">
.selector {
  position: relative;
  & > .background {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
    background: #f4f4f4;
  }
  min-height: 38px;
  overflow: hidden;
  border: 1px solid #f4f4f4;
  border-radius: 12px;
  display: flex;
  width: 100%;
  background: #fff;
  align-items: center;
  text-align: left;
  margin-bottom: 20px;
  & > ul {
    list-style: none;
    padding: 0 0 0 5px;
    margin: 0;
    font-size: 16px;
    width: calc(100% - 40px);
    display: flex;
    flex-wrap: wrap;
    & > li {
      z-index: 1;
      margin: 3px;
      padding: 2px 5px 2px 5px;
      background: #000511;
      color: #fff;
      border-radius: 9px;
      display: flex;
      align-items: center;
      & > span {
        cursor: pointer;
        display: block;
        font-size: 14px;
        &:last-child {
          font-size: 12px;
          margin-left: 5px;
          &:hover {
            opacity: 0.6;
          }
        }
      }
    }
  }
  & > span {
    cursor: pointer;
    display: block;
    width: 40px;
    text-align: center;
    font-size: 7px;
    margin-right: auto;
  }
}
</style>